<template>
     <router-view ></router-view>
</template>

 <style>
 .product_items .col-6{
     border: 1px solid #e9e8e8; 
 }
</style>
